import store from '@/store'

export function hasRole(roles) {
  const userRole = store.getters.userRole
  return roles.some((item) => {
    return userRole.includes(item)
  })
};